import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementCandidateAvailabilityUpdated_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementCandidateAvailabilityUpdated_ActivityLogFragment;
}

const ActivityLogTaskRequirementCandidateAvailabilityUpdated: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.editedAvailabilityRequest"
    />
  );
};

ActivityLogTaskRequirementCandidateAvailabilityUpdated.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementCandidateAvailabilityUpdated_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementCandidateAvailabilityUpdated;
